__webpack_require__.p = "https://bdteo.com/";